/**
 * @功能名称:
 * @文件名称: baidu.js
 * @Date: 2018/6/12 16:29.
 * @Author: yanqiuru
 * @Copyright（C）: 2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
import uri from './uri';
import ajax from './ajax.jquery';

var source = uri.getQuery('source');
var account = null;
var opt = null;

function baiduInit_() {
  if (Array.isArray(account)) {
    let baidu = account.some(item => {
      if (source >= item.lt && source <= item.gt) {
        opt = item.opt;
        return true;
      } else {
        return false;
      }
    });
    if (baidu) {
      window._agl = [];
      _agl.push(
        ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
      );
      let agl = document.createElement('script');
      agl.type='text/javascript';
      agl.async = true;
      agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(agl, s);
    }
  }
}

export function baiduPush(cb) {
  if (window._agl  && opt) {
    window._agl && window._agl.push(['track', ['success', {t: 3}]])
  }
};
export function baiduInit(url) {
  ajax.get(url).then((response) => {
    let json = response;
    if (json && json.account) {
      account = json.account;
      baiduInit_();
    }
  });
}

export default {baiduPush , baiduInit};




// WEBPACK FOOTER //
// ./src/component/common/baidu.js